import { Injectable } from '@angular/core';
import { SocialAuthService, GoogleLoginProvider, SocialUser } from '@abacritt/angularx-social-login';
import { Observable, from, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { LoggerService } from '../logger.service';

/**
 * Servicio para manejar la integración con Google Sign-In
 * Responsabilidad única: Gestionar la autenticación con Google (SOLID - SRP)
 */
@Injectable({
    providedIn: 'root'
})
export class GoogleSignInService {
    constructor(
        private socialAuthService: SocialAuthService,
        private logger: LoggerService
    ) {}

    /**
     * Inicia el flujo de autenticación con Google
     * @returns Observable con el usuario autenticado de Google
     */
    signInWithGoogle(): Observable<SocialUser> {
        this.logger.log('🔵 [GOOGLE-SIGNIN-SERVICE] Iniciando sign-in con Google');
        
        return from(
            this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID)
        ).pipe(
            map(user => {
                this.logger.log('✅ [GOOGLE-SIGNIN-SERVICE] Usuario autenticado con Google');
                this.logger.log('👤 [GOOGLE-SIGNIN-SERVICE] Email:', user.email);
                this.logger.log('👤 [GOOGLE-SIGNIN-SERVICE] Nombre:', user.name);
                return user;
            }),
            catchError(error => {
                this.logger.error('❌ [GOOGLE-SIGNIN-SERVICE] Error en Google Sign-In:', error);
                return throwError(() => new Error('Error al autenticar con Google'));
            })
        );
    }

    /**
     * Cierra la sesión de Google
     * @returns Observable que se completa cuando se cierra la sesión
     */
    signOut(): Observable<void> {
        this.logger.log('🚪 [GOOGLE-SIGNIN-SERVICE] Cerrando sesión de Google');
        
        return from(this.socialAuthService.signOut()).pipe(
            map(() => {
                this.logger.log('✅ [GOOGLE-SIGNIN-SERVICE] Sesión de Google cerrada');
            }),
            catchError(error => {
                this.logger.error('❌ [GOOGLE-SIGNIN-SERVICE] Error al cerrar sesión de Google:', error);
                return throwError(() => error);
            })
        );
    }

    /**
     * Obtiene el estado de autenticación actual
     * @returns Observable con el usuario actual o null
     */
    getAuthState(): Observable<SocialUser | null> {
        return this.socialAuthService.authState;
    }
}
